import React, { useState, useEffect } from 'react';
import { Select } from '@amzn/stencil-react-components/select';
import { Input } from '@amzn/stencil-react-components/input';
import isEmpty from 'lodash/isEmpty';

const MetricValue = ({ metricConfig, onChange, isDisabled, metricValue }) => {
  const { type, options } = metricConfig;

  return (
    <>
      {type === 'input' ? (
        <Input
          data-testid="metric-value-input"
          disabled={isDisabled}
          onChange={e => {
            onChange(e.target?.value);
          }}
          value={metricValue}
          placeholder=""
        />
      ) : null}
      {type === 'select' ? (
        <Select
          data-testid="metric-value-dropdown"
          disabled={isDisabled}
          options={options}
          value={metricValue}
          onChange={e => {
            onChange(e);
          }}
        />
      ) : null}
    </>
  );
};

export default MetricValue;
